import { useMemo } from 'react'
import { isCustomerView, parseEpssRange, setKEV } from 'utils'
import ExportCsv from 'views/Dashboard/Products/components/ExportCsv'
import SearchFilter from 'views/Sbom/components/SearchFilter'

import { Flex, IconButton, Skeleton, Stack, Tooltip } from '@chakra-ui/react'

import RefreshBtn from 'components/Icons/RefreshBtn'

import { useGlobalState } from 'hooks/useGlobalState'

import { BiScan } from 'react-icons/bi'
import { FaPen } from 'react-icons/fa'
import { FaPlus } from 'react-icons/fa6'
import { LuImport } from 'react-icons/lu'

import VulnFilters from '../../VulnFilters'

const VulnerabilitySubHeader = ({
  editVulns,
  handleClear,
  handleScan,
  handleSearch,
  VEX,
  isArchived,
  onSearchInputChange,
  IMPORT,
  prodVulnDispatch,
  reset,
  selectedVulns = [],
  signedUrlParams,
  vulnSearch,
  filters,
  CUSTOM_VULNS
}) => {
  const { prodVulnState } = useGlobalState()
  const {
    searchInput,
    severities,
    components,
    statues,
    include,
    kev,
    epss,
    direct,
    vexComplete
  } = prodVulnState

  const setOrder = useMemo(
    () => (value) => {
      if (value === '') {
        return {
          field: prodVulnState?.field,
          direction: prodVulnState?.direction
        }
      } else {
        return undefined
      }
    },
    [prodVulnState?.direction, prodVulnState?.field]
  )

  /*   getEpssRangeArray */
  const epssRange = parseEpssRange(epss)

  const subHeader = useMemo(() => {
    const customerView = isCustomerView()
    return (
      <Flex
        justifyContent={'space-between'}
        sx={{ w: '100%', gap: 2, alignItems: 'flex-start' }}
      >
        <Flex sx={{ gap: 3, flexWrap: 'wrap', alignItems: 'flex-start' }}>
          {/* SEARCH COMPONENTS */}
          <SearchFilter
            id='vuln'
            filterText={vulnSearch}
            onChange={onSearchInputChange}
            onFilter={handleSearch}
            onClear={handleClear}
          />
          {/* FILTER COMPONENTS BASED ON ECOSYSTEM FOR CUSTOMER VIEW */}
          {customerView &&
            filters &&
            (filters ? (
              <VulnFilters reset={() => reset()} />
            ) : (
              <Stack direction='row' spacing={4}>
                {[1, 2, 3, 4].map((_, index) => (
                  <Skeleton key={index} width={'100px'} height={'38px'} />
                ))}
              </Stack>
            ))}
          {/* FILTER COMPONENTS BASED ON ECOSYSTEM FOR VENDOR VIEW */}
          {!customerView && <VulnFilters reset={() => reset()} />}
        </Flex>
        <Stack direction='row' alignItems={'center'} width={'fit-content'}>
          {/* ADD CUSTOM VULNERABILITY */}
          {!customerView && (
            <Tooltip label={'Add Custom Vulnerability'}>
              <IconButton
                colorScheme='blue'
                onClick={CUSTOM_VULNS.onOpen}
                isDisabled={!editVulns}
                hidden={signedUrlParams}
                icon={<FaPlus />}
              />
            </Tooltip>
          )}
          {/* UPDATE STATUSES */}
          {!customerView && selectedVulns.length > 0 && (
            <Tooltip label={'Set Status'}>
              <IconButton
                colorScheme='blue'
                onClick={VEX.onOpen}
                isDisabled={!editVulns}
                hidden={signedUrlParams}
                icon={<FaPen />}
              />
            </Tooltip>
          )}
          {/* SCAN VULN */}
          {!customerView && (
            <Tooltip label={'Scan Vulnerabilities'}>
              <IconButton
                colorScheme='blue'
                onClick={handleScan}
                aria-label='scan_vulns'
                hidden={signedUrlParams || isArchived}
                icon={<BiScan size={20} />}
              />
            </Tooltip>
          )}

          {/* IMPORT STATUS */}
          {!customerView && (
            <Tooltip label='Import Statuses'>
              <IconButton
                variant='solid'
                colorScheme='blue'
                fontWeight='normal'
                fontSize={'sm'}
                onClick={() => {
                  prodVulnDispatch({ type: 'RESET_SELECTED_VULN' })
                  IMPORT.onOpen()
                }}
                aria-label='import_status'
                hidden={signedUrlParams || isArchived}
                isDisabled={!editVulns}
                icon={<LuImport size={20} />}
              />
            </Tooltip>
          )}
          {!customerView && (
            <ExportCsv
              tableType='SBOM Vulnerability View'
              filters={{
                search: searchInput !== '' ? searchInput : undefined,
                severity: severities.length > 0 ? severities : undefined,
                source: include.includes('parts') ? undefined : 'COMPONENT',
                componentName: components.length > 0 ? components : undefined,
                status: statues.length > 0 ? statues : undefined,
                kev: setKEV(kev),
                epss: epssRange,
                direct: direct === 'direct only' ? true : undefined,
                includeRetracted: include.includes('retracted') ? true : false,
                vexComplete: vexComplete === 'all' ? undefined : false,
                orderBy: setOrder(searchInput)
              }}
            />
          )}

          {/* REFRESH */}
          <RefreshBtn onClick={() => reset()} />
        </Stack>
      </Flex>
    )
  }, [
    editVulns,
    handleClear,
    handleScan,
    handleSearch,
    VEX,
    isArchived,
    onSearchInputChange,
    IMPORT,
    prodVulnDispatch,
    reset,
    selectedVulns.length,
    signedUrlParams,
    vulnSearch,
    filters,
    components,
    direct,
    include,
    kev,
    searchInput,
    setOrder,
    severities,
    statues,
    vexComplete,
    epssRange,
    CUSTOM_VULNS
  ])

  return subHeader
}

export default VulnerabilitySubHeader
